import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Ponte en Contacto</span>
          <h2 className="section-title">Comencemos Tu Viaje Inmobiliario</h2>
          <p className="section-subtitle">
            ¿Lista para hacer realidad tus sueños inmobiliarios? Estoy aquí para ayudarte en cada paso del camino.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Información de Contacto</h3>
            <p className="contact-intro">
              Siéntete libre de contactarme a través de cualquiera de estos canales. Típicamente respondo dentro de 2-4 horas durante días hábiles.
            </p>
            
            <div className="contact-methods">
              <div className="contact-method">
                <div className="icon">📱</div>
                <div className="details">
                  <h4>Teléfono</h4>
                  <a href="tel:+593995410584">+593 99 541 0584</a>
                  <span className="availability">Disponible 7 días a la semana</span>
                </div>
              </div>

              <div className="contact-method">
                <div className="icon">💬</div>
                <div className="details">
                  <h4>WhatsApp</h4>
                  <a href="https://wa.me/593995410584" target="_blank" rel="noopener noreferrer">Enviar Mensaje</a>
                  <span className="availability">Respuesta rápida</span>
                </div>
              </div>

              <div className="contact-method">
                <div className="icon">📧</div>
                <div className="details">
                  <h4>Email</h4>
                  <a href="mailto:karen@jkrealty.ec">karen@jkrealty.ec</a>
                  <span className="availability">Consultas detalladas por escrito</span>
                </div>
              </div>

              <div className="contact-method">
                <div className="icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </div>
                <div className="details">
                  <h4>Instagram</h4>
                  <a href="https://www.instagram.com/jk_realty_uio/" target="_blank" rel="noopener noreferrer">@jk_realty_uio</a>
                  <span className="availability">Sígueme para ver propiedades</span>
                </div>
              </div>
            </div>

          </div>

          <div className="contact-logo-right">
            <img src="/LandingPageAssets/Logos/jk-logo-full-600.png" alt="J&K Realty" className="contact-side-logo" width="600" height="136" loading="lazy" />
          </div>

        </div>

        <div className="contact-cta">
          <h3>¿Prefieres una Llamada Rápida?</h3>
          <p>Estoy a solo una llamada de distancia y lista para ayudarte con tus necesidades inmobiliarias</p>
          <a href="tel:+593995410584" className="btn btn-secondary btn-large">
            📞 Llamar +593 99 541 0584
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
